const statusColors: Record<string, string> = {
  raw: 'bg-gray-600 text-gray-200',
  pending: 'bg-gray-600 text-gray-200',
  queued: 'bg-yellow-900 text-yellow-200',
  processing: 'bg-blue-900 text-blue-200',
  transcribed: 'bg-cyan-900 text-cyan-200',
  manufactured: 'bg-purple-900 text-purple-200',
  complete: 'bg-green-900 text-green-200',
  completed: 'bg-green-900 text-green-200',
  error: 'bg-red-900 text-red-200',
}

const statusLabels: Record<string, string> = {
  raw: 'خام',
  pending: 'منتظر',
  queued: 'في الطابور',
  processing: 'جاري',
  transcribed: 'مفرّغ',
  manufactured: 'مصنّع',
  complete: 'مكتمل',
  completed: 'مكتمل',
  error: 'خطأ',
}

export default function StatusBadge({ status }: { status: string }) {
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${statusColors[status] || 'bg-gray-700 text-gray-300'}`}>
      {statusLabels[status] || status}
    </span>
  )
}
